export const option = {
  height: '400',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: '修改',
  editTitle: '修改',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: true,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '租赁人',
      prop: 'name',
      display: false,
      search: false,
    },
    {
      label: '产品类型',
      prop: 'rentTypeName',
      display: false,
      search: false,
    },
    {
      label: '租率',
      prop: 'lendingRateString',
      display: false,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      display: false,
    },
    {
      label: '已结清期数',
      prop: 'currentTenancy',
      span: 24,
      search: false,
      display: false,
    },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
    {
      label: '返佣比例',
      prop: 'rakeBackRate',
      span: 24,
      display: false,
      formatter: (val, value, label) => {
        return value ? value + '' : '';
      },
    },
    {
      label: '返佣金额',
      prop: 'rakeBackMoney',
      span: 24,
      display: true,
    },
  ],
};
